import React, { ReactNode, useContext } from "react";
import { Navigate } from "react-router-dom";
import AuthContext from "contextAPI/authProvider";
import { getTokenExpiration } from "Common/Components/getRoleId";

interface AuthProtectedProps {
  children: ReactNode;
}

const AuthProtected: React.FC<AuthProtectedProps> = ({ children }) => {
  const tokenExpiration = getTokenExpiration(localStorage.getItem("app_at_mahan"));
  const accesstoken = localStorage.getItem("app_at_mahan");
  const refreshtoken = localStorage.getItem("app_rt_mahan");

  // if (
  //   !accesstoken ||
  //   !refreshtoken ||
  //   (tokenExpiration && tokenExpiration.getTime() < Date.now())
  // ) {
  //   return <Navigate to="/login" />;
  // }
  return <>{children}</>;
};
export default AuthProtected;

// import useAuth from "hooks/useAuth";
// import React, { ReactNode } from "react";
// import { Navigate } from "react-router-dom";

// interface AuthProtectedProps {
//   children: ReactNode;
// }

// const AuthProtected: React.FC<AuthProtectedProps> = ({ children }) => {
//   const {auth} = useAuth()
//   if (!localStorage.getItem("authUser") && auth) {
//     return <Navigate to={{ pathname: "/login" }} />;
//   }
//   return <React.Fragment>{children}</React.Fragment>;
// };

// export default AuthProtected;
